// extracted by mini-css-extract-plugin
export default {"submitButtonContainer":"BackToAdminButton_submitButtonContainer__6nFG0","submitButton":"BackToAdminButton_submitButton__5V9z7"};